export enum QuantityActionType {
  PLUS = 'Plus',
  MINUS = 'Minus',
}
